(function () {
  window.addEventListener('load', function () {
    const ratings = document.querySelectorAll(
      '[data-oke-reviews-product-listing-rating]',
    );

    if (!ratings.length) {
      return;
    }

    ratings.forEach(function (rating) {
      if (rating.children.length) {
        for (let child of rating.children) {
          if (child.textContent.trim() == '') {
            rating.style.display = 'none';
          }
        }
      }
    });
  });

  // Add UTM params to product links in collections with '-paid' in the URL
  window.addEventListener('DOMContentLoaded', function () {
    function addUTMParams(productCardLinks, paramName, paramValue) {
      productCardLinks.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set(paramName, paramValue);
        link.href = url.toString();
      });
    }

    if (document.querySelector('.js-collection-33-percent-off')) {
      const collectionGrid = document.querySelector(
        '.js-collection-33-percent-off .multivitamins-collection__grid',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.multivitamins-collection__grid a',
      );

      addUTMParams(productCardLinks, '_mv_lp_33', 'true');
    }

    if (document.querySelector('.js-collection-4week-plan')) {
      const collectionGrid = document.querySelector(
        '.js-collection-4week-plan .multivitamins-collection__grid',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.multivitamins-collection__grid a',
      );

      addUTMParams(productCardLinks, 'plan_type', '4w');
    }

    if (document.querySelector('.js-collection-25-percent-off')) {
      const collectionGrid = document.querySelector(
        '.js-collection-25-percent-off .multivitamins-collection__grid',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.multivitamins-collection__grid a',
      );
      addUTMParams(productCardLinks, '_mv_lp_25', 'true');
    }

    if (document.querySelector('.js-collection-paid')) {
      const collectionGrid = document.querySelector(
        '.js-collection-paid .multivitamins-collection__grid',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.multivitamins-collection__grid a',
      );

      productCardLinks.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set('status', 'paid');
        link.href = url.toString();
      });
    }

    if (document.querySelector('section.js-collection-patients')) {
      const collectionGrid = document.querySelector(
        'section.js-collection-patients .collection__products',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.collection__products__item a',
      );

      productCardLinks.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set('status', 'patients');
        link.href = url.toString();
      });
    }

    function addHeroImageParams() {
      console.log('addHeroImageParams');
      const heroLinks = document.querySelectorAll(
        '.multivitamins-collection__grid a',
      );

      if (window.location.search.toLowerCase().includes('heroimage=herov2')) {
        heroLinks.forEach((link) => {
          const url = new URL(link.href);
          url.searchParams.set('heroimage', 'herov2');
          link.href = url.toString();
        });
      }
      if (window.location.search.toLowerCase().includes('heroimage=herov3')) {
        heroLinks.forEach((link) => {
          const url = new URL(link.href);
          url.searchParams.set('heroimage', 'herov3');
          link.href = url.toString();
        });
      }
    }

    addHeroImageParams();
  });
})();
